if ($('.togglePersons').length) {
    $('.togglePersons').on("click", function () {
        $(this).toggleClass('__active');
        $('.togglePersonsContainer').slideToggle();
    });
}